module.exports = __webpack_public_path__ + "img/empty-photo-icon.28c6163d.svg";